import type { StaticContentEntity } from '@core-api/presentation/types/response';

export const isFullSizeImageSlide = (staticContent: StaticContentEntity) => {
  const isImageSlide = staticContent.type === 'image';
  if (isImageSlide) {
    return staticContent.imagePosition === 'background';
  }
  return false;
};

export const getHasFullWidthImageLayout = (
  staticContent: StaticContentEntity,
) => {
  if ('image' in staticContent) {
    const { start, end } = staticContent.image?.imageLayoutPosition ?? {
      start: 0,
      end: 0,
    };

    const numberOfGridColumns = staticContent.layout?.gridColumns ?? 0;

    return start === 1 && end === numberOfGridColumns;
  } else {
    return false;
  }
};
